$(document).ready(function () {
    new nc.promokit.Preloader({
        'game': 'bns',
    	'delay': 1000,
		'image': [
			'/promo/bns/history/2019/190821_destroyer/img/bg_sec_1.jpg',
			'/promo/bns/history/2019/190821_destroyer/img/bg_sec_2.jpg',
			'/promo/bns/history/2019/190821_destroyer/img/bg_sec_3.jpg',
			'/promo/bns/history/2019/190821_destroyer/img/btn_home.png',
			'/promo/bns/history/2019/190821_destroyer/img/btn_scroll.png',
			'/promo/bns/history/2019/190821_destroyer/img/btn_today.png',
			'/promo/bns/history/2019/190821_destroyer/img/bubble_1.png',
			'/promo/bns/history/2019/190821_destroyer/img/bubble_2.png',
			'/promo/bns/history/2019/190821_destroyer/img/bul_after.png',
			'/promo/bns/history/2019/190821_destroyer/img/bul_before.png',
			'/promo/bns/history/2019/190821_destroyer/img/bul_text.png',
			'/promo/bns/history/2019/190821_destroyer/img/chr_1.png',
			'/promo/bns/history/2019/190821_destroyer/img/copyright.png',
			'/promo/bns/history/2019/190821_destroyer/img/em_1_off.png',
			'/promo/bns/history/2019/190821_destroyer/img/em_1_on.png',
			'/promo/bns/history/2019/190821_destroyer/img/em_2_off.png',
			'/promo/bns/history/2019/190821_destroyer/img/em_2_on.png',
			'/promo/bns/history/2019/190821_destroyer/img/em_3_off.png',
			'/promo/bns/history/2019/190821_destroyer/img/em_3_on.png',
			'/promo/bns/history/2019/190821_destroyer/img/em_4_off.png',
			'/promo/bns/history/2019/190821_destroyer/img/em_4_on.png',
			'/promo/bns/history/2019/190821_destroyer/img/etc_menu.png',
			'/promo/bns/history/2019/190821_destroyer/img/label_1.png',
			'/promo/bns/history/2019/190821_destroyer/img/label_2.png',
			'/promo/bns/history/2019/190821_destroyer/img/label_3.png',
			'/promo/bns/history/2019/190821_destroyer/img/label_4.png',
			'/promo/bns/history/2019/190821_destroyer/img/logo_bns.png',
			'/promo/bns/history/2019/190821_destroyer/img/quick_off.png',
			'/promo/bns/history/2019/190821_destroyer/img/quick_on.png',
			'/promo/bns/history/2019/190821_destroyer/img/sec_1_efc1.png',
			'/promo/bns/history/2019/190821_destroyer/img/sec_1_efc2.png',
			'/promo/bns/history/2019/190821_destroyer/img/sec_1_label.png',
			'/promo/bns/history/2019/190821_destroyer/img/sec_1_text.png',
			'/promo/bns/history/2019/190821_destroyer/img/sec_1_tit.png',
			'/promo/bns/history/2019/190821_destroyer/img/sec_2_char.png',
			'/promo/bns/history/2019/190821_destroyer/img/sec_2_char_o.png',
			'/promo/bns/history/2019/190821_destroyer/img/sec_2_efc.png',
			'/promo/bns/history/2019/190821_destroyer/img/sec_2_label.png',
			'/promo/bns/history/2019/190821_destroyer/img/sec_2_text.png',
			'/promo/bns/history/2019/190821_destroyer/img/sec_2_tit.png',
			'/promo/bns/history/2019/190821_destroyer/img/sec_3_char.png',
			'/promo/bns/history/2019/190821_destroyer/img/sec_3_char_o.png',
			'/promo/bns/history/2019/190821_destroyer/img/sec_3_efc.png',
			'/promo/bns/history/2019/190821_destroyer/img/sec_3_label.png',
			'/promo/bns/history/2019/190821_destroyer/img/sec_3_text.png',
			'/promo/bns/history/2019/190821_destroyer/img/sec_3_tit.png',
			'/promo/bns/history/2019/190821_destroyer/img/smog_1_1.png',
			'/promo/bns/history/2019/190821_destroyer/img/smog_1_2.png',
			'/promo/bns/history/2019/190821_destroyer/img/smog_1_3.png',
			'/promo/bns/history/2019/190821_destroyer/img/smog_2_1.png',
			'/promo/bns/history/2019/190821_destroyer/img/smog_2_2.png',
        ],
        'video':[],
        'youtbue':[],
    });

    $(document).on('preloadend', function(){
        setTimeout(function(){
            $('#container').css('opacity',1).addClass('active');
            pageMain.init();
			pageMain.setMotion();
        }, 500);
    });
});

var Scroll = (function(){
    var init, action, bindEvent, quick;
    var $cont, sclTop, obj, i, winHeight = $(window).height()-$(window).height()/2, PageInfo = {};

    init = function(){
        var len;
        $cont = $('[data-scroll]');
        len = $cont.length;
        PageInfo = {};

        while(len--){
            PageInfo[$cont.eq(len).data('scroll')] = {
                flag: false,
                offset: $cont.eq(len).offset(),
                showMotion: arguments[len] || ''
            };
        }

        action();
        bindEvent();
        quick();
    };

    action = function(){
        i = Object.keys(PageInfo).length;
        sclTop = $(window).scrollTop() + winHeight;
        while( i-- ){
            obj = PageInfo['scroll-'+(i+1)+''];
            if( sclTop >= obj.offset.top ){
                if( !obj.flag ){
                    obj.showMotion();
                    obj.flag = true
                }
            }
        }
    };

    bindEvent = function(){
        $(window).scroll(function(){
            action();
        });
        $(window).resize(function(){
            winHeight = $(window).height()-$(window).height()/2;
			var h = $(window).height() - 33;
			$('#section-1').height(h);
        });
		var $event = $('.event ul li');
		$event.on('mouseenter', 'a',function(){
			$(this).closest('ul').addClass('default');
			$(this).closest('li').addClass('hover');
		});
		$event.on('mouseleave', 'a',function(){
			$(this).closest('ul').removeClass('default');
			$(this).closest('li').removeClass('hover');
		});
    };

    quick = function(){
        var $menu = $('.quick-menu ul li'),
            $contents = $('.target');

        var scltop = $(window).scrollTop();
        if (0 === scltop){
            $menu.eq(0).find('a').addClass('active');
        }
        check(scltop);
        $menu.on('click', 'a.qm', function (e) {
            e.preventDefault();
            var target = $(this).attr("href"),
                offsetTop = $(target).offset().top;
            var $doc = $('html, body');
            $doc.stop()
                .animate({
                    scrollTop: offsetTop-33
                }, 800)
        });

        $(window).scroll(function () {
            var scltop = $(window).scrollTop();
            check(scltop);

        });

        function check(scltop){
            $.each($contents, function (idx, item) {
                var $target = $contents.eq(idx),
                    i = idx,
                    targetTop = $target.offset().top - 400;
                if (targetTop <= scltop) {
					$menu.closest('ul').removeClass().addClass('m-'+i);
                    $menu.find('a').removeClass('active');
                    $menu.eq(i).find('a').addClass('active');
					pageNum = i;
                }
            });
        }
    };

    return{
        init: init
    }
})();
var pageMain = (function(){
	var init, setMotion, Motion, controls, tl1, tl2, tl3;
	tl1 = new TimelineMax({paused:true});
	tl2 = new TimelineMax({paused:true});
	tl3 = new TimelineMax({paused:true});
	init = function(){
		var h = $(window).height() - 33;
		$('#section-1').height(h);
		controls();
		Motion.m1();
		Scroll.init(Motion.m2, Motion.m3);
	};
	controls = function(){
		$('.btn_scroll').on('click', function (e) {
            e.preventDefault();
            var target = $(this).attr("href"),
                offsetTop = $(target).offset().top;
            var $doc = $('html, body');
            $doc.stop()
                .animate({
                    scrollTop: offsetTop-33
                }, 800);
        });
	};
	setMotion = function(){
		tl1.addLabel('init')
		.fromTo($('#section-1').find('.char'), 1.3, {y:0, x:0, scale:0.2, opacity: 0 }, {y:0, x:0, scale:1, opacity: 1, ease: Power3.easeInExpo}, 'init+=0.4')
		.fromTo($('#section-1').find('.effect2'), 1, { opacity: 0, scale:0.95 }, { opacity: 1, scale:1, ease: Power2.easeOut }, 'init+=1.15')
		.addLabel('after')
		.fromTo($('#section-1').find('.effect1'), 1, { opacity: 0 }, { opacity: 1, ease: Bounce.easeOut }, 'init+=1.88')
		.add(function(){$('#section-1').find('.effect1').addClass('active');}, 'after+=0.3')
		.add(function(){$('.quick-menu').addClass('on');}, 'after+=0.6')
		.fromTo($('#section-1').find('.label'), 0.8, { y: -20, opacity: 0 }, { y: 0, opacity: 1, ease: Power3.easeOut }, 'init+=2.3')
		.fromTo($('#section-1').find('.label .before'), 1, { x: -20, opacity: 0 }, { x: 0, opacity: 1, ease: Power3.easeOut }, 'init+=2.5')
		.fromTo($('#section-1').find('.label .after'), 1, { x: 20, opacity: 0 }, { x: 0, opacity: 1, ease: Power3.easeOut }, 'init+=2.5')
		.fromTo($('#section-1').find('.tit'), 1, { y: 50, opacity: 0 }, { y: 0, opacity: 1, ease: Power3.easeOut }, 'init+=2.75')
		.fromTo($('#section-1').find('.text'), 1, { y: 50, opacity: 0 }, { y: 0, opacity: 1, ease: Power3.easeOut }, 'init+=3.1')
		.fromTo($('#section-1').find('.smog1'), 2, {opacity: 0 }, {opacity: 1, ease: Power2.easeOut }, 'init+=1.5')
		.fromTo($('#section-1').find('.smog2'), 2, {opacity: 0 }, {opacity: 1, ease: Power2.easeOut }, 'init+=1.5')
		.fromTo($('#section-1').find('.smog3'), 2, {opacity: 0 }, {opacity: 1, ease: Power2.easeOut }, 'init+=1.5')
		.fromTo($('#section-1').find('.event ul'), 0.6, { opacity: 0, y: -30 }, { opacity: 1, y: 0, ease: Power3.easeOut }, "init+=3.35" )
		.fromTo($('#section-1').find('.btn_scroll'), 0.9, { y: -30, opacity: 0 }, { y: 0, opacity: 1, ease: Power3.easeOut }, 'init+=3.5')
		.staggerFromTo($('#section-1').find('.etc_menu li'), 0.6, { opacity: 0, x: -30 }, { opacity: 1, x: 0, ease: Power3.easeOut },0.25, "init+=3.65" );

		tl2.addLabel('init')
		.fromTo($('#section-2').find('.char-1'), 1, {opacity: 0, x: 300, y: 0}, {opacity: 0.1, x: 0, y: 0, ease: Expo.easeInOut}, 'init+=0.05')
        .fromTo($('#section-2').find('.char-2'), 1, {opacity: 0, x: 300, y: 0}, {opacity: 0.4, x: 0, y: 0, ease: Expo.easeInOut}, 'init+=0.1')
        .fromTo($('#section-2').find('.char-3'), 1, {opacity: 0, x: 300, y: 0}, {opacity: 1, x: 0, y: 0, ease: Expo.easeInOut}, 'init+=0.2')
		.fromTo($('#section-2').find('.glow'), 1, {opacity: 0}, {opacity: 1, ease: Bounce.easeInOut}, 'init+=0.4')
		.addLabel('after')
		.fromTo($('#section-2').find('.effect'), 0.8, { scale:0, opacity: 0 }, { scale:1, opacity: 1, ease: Power2.easeOut }, 'init+=0.35')
		.add(function(){$('#section-2').find('.effect').addClass('active');}, 'after+=0.6')
		.fromTo($('#section-2').find('.label'), 0.8, { y: 50, opacity: 0},{ y: 0, opacity: 1,ease: Power3.easeOut }, 'init+=1.35')
		.fromTo($('#section-2').find('.tit'), 0.8, { y: 50, opacity: 0},{ y: 0, opacity: 1, ease: Power3.easeOut }, 'init+=1.5')
		.fromTo($('#section-2').find('.text'), 0.5, { y: 20, opacity: 0 }, { y: 0, opacity: 1, ease: Power2.easeOut }, 'init+=1.75')
		.fromTo($('#section-2').find('.smog1'), 2, {opacity: 0 }, {opacity: 1, ease: Power2.easeOut }, 'init+=0.9')
		.fromTo($('#section-2').find('.smog2'), 2, {opacity: 0 }, {opacity: 1, ease: Power2.easeOut }, 'init+=0.9');

		tl3.addLabel('init')
		.fromTo($('#section-3').find('.char-1'), 1, {opacity: 0, x: 0, y: 0, scale:0.6}, {opacity: 0.1, x: 0, y: 0, scale:1, ease: Expo.easeInOut}, 'init+=0.05')
        .fromTo($('#section-3').find('.char-2'), 1, {opacity: 0, x: 0, y: 0, scale:0.6}, {opacity: 0.4, x: 0, y: 0, scale:1, ease: Expo.easeInOut}, 'init+=0.1')
        .fromTo($('#section-3').find('.char-3'), 1, {opacity: 0, x: 0, y: 0, scale:0.6}, {opacity: 1, x: 0, y: 0, scale:1, ease: Expo.easeInOut}, 'init+=0.2')
		.fromTo($('#section-3').find('.glow'), 1, {opacity: 0}, {opacity: 1, ease: Bounce.easeInOut}, 'init+=0.4')
		.addLabel('after')
		.fromTo($('#section-3').find('.effect'), 0.8, { scale:0, opacity: 0 }, { scale:1, opacity: 1, ease: Power2.easeOut }, 'init+=0.48')
		.add(function(){$('#section-3').find('.effect').addClass('active');}, 'after+=0.6')
		.fromTo($('#section-3').find('.label'), 0.8, { y: 50, opacity: 0},{ y: 0, opacity: 1,ease: Power3.easeOut }, 'init+=1.35')
		.fromTo($('#section-3').find('.tit'), 0.8, { y: 50, opacity: 0},{ y: 0, opacity: 1, ease: Power3.easeOut }, 'init+=1.5')
		.fromTo($('#section-3').find('.text'), 0.5, { y: 20, opacity: 0 }, { y: 0, opacity: 1, ease: Power2.easeOut }, 'init+=1.75');

	}
	Motion = (function(){
		var m1, m2, m3;

		m1 = function(){
			tl1.seek(0);
			tl1.play(0);
		};

		m2 = function(){
			tl2.seek(0);
			tl2.play(0);
		};

		m3 = function(){
			tl3.seek(0);
			tl3.play(0);
		};

		return{
			m1: m1,
			m2: m2,
			m3: m3
		}
	})();

    return{
        init: init,
		setMotion: setMotion
    }
})();



// WEBPACK FOOTER //
// ./src/js/index.js